














import { Component, Vue } from "vue-property-decorator";
import { setting } from "@/store/index";

@Component({
  components: {
    "champion-deck-origin": () =>
      import("@/components/Organisms/ChampionDeckOrigin.vue"),
    "champion-deck-class": () =>
      import("@/components/Organisms/ChampionDeckClass.vue"),
    "champion-deck-favorite": () =>
      import("@/components/Organisms/ChampionDeckFavorite.vue"),
    "tft-header": () => import("@/components/Organisms/Header.vue"),
    "tft-drawer": () => import("@/components/Organisms/Drawer.vue"),
    "champion-footer": () =>
      import("@/components/Organisms/ChampionFooter.vue"),
    "champion-side-pick": () =>
      import("@/components/Organisms/ChampionSidePick.vue")
  }
})
export default class ChampionPage extends Vue {
  windowSize = 0;
  created() {
    setting.loadSetting();
  }
  get visibleSynegyViewer(): boolean {
    return setting.visibleSideSynergyViewer;
  }
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, true);
    }
  }
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  }
  onResize() {
    this.windowSize = window.innerWidth;
  }
}
